import React from 'react';
import { X } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

const CategoryModal = ({ category, isOpen, onClose }) => {
  if (!isOpen || !category) return null;

  const IconComponent = LucideIcons[category.icon] || LucideIcons.Circle;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="bg-white/95 backdrop-blur-md rounded-2xl max-w-md w-full mx-4 relative transform transition-all duration-300 animate-modal-enter shadow-xl border border-white/20">
        {/* Decorative Background Elements */}
        <div className="absolute -top-2 -right-2 w-16 h-16 bg-gradient-to-br from-[#4b9fcc]/15 to-[#e71f74]/15 rounded-full blur-lg"></div>
        <div className="absolute -bottom-3 -left-3 w-20 h-20 bg-gradient-to-tr from-[#e71f74]/10 to-[#4b9fcc]/10 rounded-full blur-xl"></div>
        
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-[#e71f74] transition-all duration-300 rounded-full hover:bg-white/60 backdrop-blur-sm hover:scale-110 z-10"
        >
          <X size={20} />
        </button>

        {/* Modal Content */}
        <div className="relative p-6">
          {/* Header with Icon */}
          <div className="text-center mb-6">
            <div className="relative inline-flex items-center justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-[#4b9fcc]/20 to-[#e71f74]/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/30 shadow-md">
                <IconComponent className="w-8 h-8 text-[#4b9fcc]" />
              </div>
              {/* Subtle decorative ring */}
              <div className="absolute -inset-1 bg-gradient-to-r from-[#4b9fcc]/20 to-[#e71f74]/20 rounded-2xl blur-sm opacity-40"></div>
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
              {category.title}
            </h3>
          </div>
          
          {/* Content */}
          <div className="relative">
            <div className="bg-gradient-to-br from-white/70 to-gray-50/70 backdrop-blur-sm rounded-xl p-5 border border-white/30 shadow-inner">
              <p className="text-gray-700 leading-relaxed text-base mb-6">
                {category.description}
              </p>
              
              {/* Decorative separator */}
              <div className="w-12 h-0.5 bg-gradient-to-r from-[#4b9fcc] to-[#e71f74] rounded-full mx-auto mb-6"></div>
              
              {/* Action Button */}
              <div className="flex justify-center">
                <button
                  onClick={onClose}
                  className="group relative px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-medium transition-all duration-300 transform hover:scale-105 hover:bg-[#4b9fcc] hover:text-white hover:shadow-lg border border-gray-200"
                >
                  {/* Button text */}
                  <span className="relative z-10 flex items-center gap-2">
                    Fermer
                    <LucideIcons.X className="w-4 h-4" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;